let waitingWorker = null;

export function setWaitingWorker(worker) {
  waitingWorker = worker || null;
}

export function applyPwaUpdate() {
  if (!waitingWorker) return false;
  waitingWorker.postMessage({ type: "SKIP_WAITING" });
  waitingWorker = null;
  return true;
}
